<template>
  <user-card title="Datos del comprador - Tus datos como comprador"
    :color="this.configurations.data.header_color"
  >
    <v-row>
      <validation-provider name="Nombre" rules="required" v-slot="{ errors }">
        <v-text-field
          class="mr-2"
          name="name"
          :value="value.name"
          :disabled="web_checkout.origin_name"
          @input="text => onTextChanged('name', text)"
          label="Nombre"
          :error-messages="errors"
          autofocus
        />
      </validation-provider>
      <validation-provider name="Apellido" rules="required" v-slot="{ errors }">
        <v-text-field
          class="ml-lg-2 ml-md-2"
          name="lastname"
          :disabled="web_checkout.origin_lastname"
          :value="value.lastname"
          @input="text => onTextChanged('lastname', text)"
          label="Apellido"
          :error-messages="errors"
        />
      </validation-provider>
    </v-row>

    <v-row>
      <validation-provider
        name="Tipo de documento"
        rules="required"
        v-slot="{ errors }"
        v-if="false"
      >
        <v-autocomplete
          :value="value.documentType"
          @input="text => onTextChanged('documentType', text)"
          label="Tipo de documento"
          :items="[
            { id: 'CC', name: 'Cédula de ciudadanía' },
            { id: 'NIT', name: 'NIT' },
            { id: 'CE', name: 'Cédula de extranjería' },
            { id: 'TI', name: 'Tarjeta de identidad' },
            { id: 'PP', name: 'Pasaporte' }
          ]"
          item-value="id"
          item-text="name"
          :error-messages="errors"
        />
      </validation-provider>
      <validation-provider
        name="Documento"
        rules="required|numeric"
        v-slot="{ errors }"
        v-if="false"
      >
        <v-text-field
          class="ml-lg-2 ml-md-2"
          :value="value.document"
          @input="text => onTextChanged('document', text)"
          name="document"
          :disabled="web_checkout.origin_document"
          v-mask="['##########']"
          label="Documento"
          :error-messages="errors"
        />
      </validation-provider>
    </v-row>

    <v-row>
      <v-col cols="9" class="pa-0">
        <validation-provider
          name="Email"
          rules="required|email"
          v-slot="{ errors }"
        >
          <v-text-field
            name="email"
            :value="value.email"
            :disabled="web_checkout.origin_email"
            @input="text => onTextChanged('email', text)"
            label="E-mail"
            :error-messages="errors"
          />
        </validation-provider>
      </v-col>
    </v-row>

    <v-row>
      <validation-provider
        name="Celular comprador"
        rules="required|phone:10"
        v-slot="{ errors }"
      >
        <v-text-field
          name="phone"
          class="mr-2"
          :value="value.phone"
          :disabled="web_checkout.origin_phone"
          @input="text => onTextChanged('phone', text)"
          v-mask="'### ### ####'"
          label="Celular comprador"
          :error-messages="errors"
        />
      </validation-provider>
    </v-row>

    <v-row>
      <validation-provider
        name="Opciones"
        v-if="this.sublink"
      >
        <v-autocomplete
          :value="group"
          @input="text => onGroupChanged(text)"
          label="Grupo destino"
          :items="sublink_options.options"
          item-value="id"
          item-text="name"
        />
      </validation-provider>
    </v-row>
    
    <v-row>
      <validation-provider
        name="reference"
        v-if="this.reference"
      >
        <v-text-field
          name="reference"
          class="mr-2"
          :value="value.transaction_id"
          @input="text => onTextChanged('transaction_id', text)"
          label="Referencia"
          :error-messages="errors"
        />
      </validation-provider>
    </v-row>

    <v-row>
      <validation-provider
        name="Términos y condiciones"
        rules="required"
        v-slot="{ errors }"
      >
        <v-checkbox v-model="value.tyc" :error-messages="errors">
          <template v-slot:label>
            <span>
              Acepto los
              <a
                href="https://soyveci.com/nuestras-politicas/"
                target="_blank"
                @click.stop=""
              >
                &nbsp;términos, condiciones, y política tratamiento de datos
              </a>
            </span>
          </template>
        </v-checkbox>
      </validation-provider>
    </v-row>
  </user-card>
</template>
<script>
import UserCard from "./UserCard.vue";
import { mask } from "vue-the-mask";

export default {
  components: { UserCard },
  directives: { mask },
  props: { 
    value: { type: Object, default: () => {} },
    web_checkout: { type: Object, default: () => {} },
    sublink: { type: Boolean, default: false },
    reference: { type: Boolean, default: false },
    sublink_options: { type: Object, default: () => {} },
    group: { type: Object, default: () => {} },
    configurations: { type: Object, default: () => {} }
  },
  data() {
    return {};
  },
  methods: {
    onTextChanged(field, text) {
      //alert(JSON.stringify(this.value))
      this.$emit("input", { ...this.value, [field]: text });
    },
    onGroupChanged(text) {
      this.$emit('groupChange', text );
    }
  }
};
</script>
